export default class LegendSkeleton {
  html () {
    return `
      <div class="legend-items border-b border-slate-200 pb-4">
        ${this.emtpyItems.join('')}
      </div>
    `
  }

  get emtpyItems () {
    return [...Array(5)].map(() => {
      return `
        <div class="flex justify-center items-center py-1">
          <div class="legend-color bg-slate-300"></div>
          <span class="legend-label-skeleton loadbar">
            <div class="mover loadbar-mover">
            </div>
          </span>
        </div>
      `
    })
  }
}
